
import { getElementSize } from '../@tix02/utility/dom';
import { select } from '../@tix02/utility/dom';
import PerfectScrollbar from 'perfect-scrollbar';

export default () => {
	const navbar = select('.main-navbar').first;
	if(! navbar) {
		return;
	}
	
	const nav = select('.primary-nav', navbar).first;
	
	const CSS_PROPERTY = '--expanded-height';
	
	const _setExpandedHeight = () => {
		const rootHeight = getElementSize(navbar).height;
		const submenus = select('.submenu', navbar).all();
		const heights = submenus.map(sm => getElementSize(sm).height);
		const max = Math.max(...heights);
		navbar.style.setProperty(CSS_PROPERTY, `${rootHeight + max}px`);
	};
	
	
	let primaryNavScroll = null;
	const _primaryNavScroll = () => {
		if(! nav ) {
			return;
		}
		
		if( window.matchMedia('screen and (max-width: 63.99rem)').matches ) {
			if( primaryNavScroll === null ) {
				primaryNavScroll = new PerfectScrollbar(nav, {
					suppressScrollX: true,
				});
			}
			return;
		}
		
		if( primaryNavScroll !== null ) {
			primaryNavScroll.destroy();
			primaryNavScroll = null;
		}
	};
	
	
	const onResize = () => {
		_setExpandedHeight();
		_primaryNavScroll();
	};
	
	
	window.addEventListener('resize', onResize);
	onResize();
};